import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DeleteIcon from "@material-ui/icons/Delete";
import { colors, IconButton, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesAutoPurch,
    useStylesLbl,
    useStylesAutoSafe,
    useStylesTF,
    useStylesAuto,
} from '../../../../../St/Reports/UseStyle';
import { Autocomplete } from "@material-ui/lab";
const useStyles = makeStyles((theme) => ({
    table: {
         minHeight: 150,
    },
}));

export default function ItemsCompsTable(props) {
    const { itemsComms, setItemsComms, setConfirmDialog, items,setItems } = props;
    const handleFocus = (e) => e.target.select();
    const [rowItem, setRowItem] = useState({});


    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasSaf = useStylesAutoSafe();
    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 12,
        color: "#000"
    }
    const handleOpenUpdate = (props, e, row) => {
        var newDataUnit = itemsComms.filter((obj) => obj.editUnit === true);
        var newDataquan = itemsComms.filter((obj) => obj?.editquan === true);

        if (rowItem?.no != null) {
            if (newDataUnit.length != 0 && props !== "editUnit") {
                EnterChangeTtems("unit", rowItem, row);
                setRowItem({});
            }
            else if (newDataquan.length != 0 && props !== "editquan") {
                EnterChangeTtems("mat_quan", rowItem, row);
                setRowItem({});
            }

        } else {
            e.preventDefault();
            setRowItem({ ...row });
            const index = row?.no;
            const dataUpdate = [...itemsComms];
            dataUpdate[index] = {
                ...row,
                [props]: true,
            };
            setItemsComms([...dataUpdate]);
        }

    };

    const MathChangIdataTtems = (prop, row) => (event) => {
        setRowItem({
            ...rowItem,
            [prop]: event.target.value,
        });
    };
    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            mat_quan: Number(rowItem.mat_quan),
            mat_quantot: Number(rowItem.mat_quantot),
            perc: Number(rowItem.perc),
        };
        let totQuan=parseFloat(i.mat_quan*i.perc).toFixed(4);
        const index = row?.no;
        const dataUpdate = [...itemsComms];
        dataUpdate[index] = {
            ...rowItem,
            mat_quan:i.mat_quan,
            mat_quantot: totQuan,
            perc: i.perc,
            editquan: false,
            editUnit: false,
        };
        setItemsComms([...dataUpdate]);
        let purch=dataUpdate?.reduce((a, v) => (a = a + parseFloat(v.price* v.mat_quan)), 0).toFixed(2);
        setItems({...items,purch_price:purch})
        setRowItem({});

    };


    const changeAutoUnits = (row, newValue) => {
        let i = {
            mat_quan: Number(row.mat_quan),
            perc: Number(newValue.perc),
            price: Number(newValue.purch),
        };
        let totQuan=parseFloat(i.mat_quan*i.perc).toFixed(4);
        const index = row?.no;
        const dataUpdate = [...items];
        dataUpdate[index] = {
            ...row,
            mat_unit: newValue.unit,
            unitName: newValue.unitName,
            mat_quantot: totQuan,
            price: i.price,
            perc:i.perc,
            editquan: false,
            editUnit: false,
        };
        setItemsComms([...itemsComms]);
        let purch=dataUpdate?.reduce((a, v) => (a = a + parseFloat(v.price* v.mat_quan)), 0).toFixed(2);
        setItems({...items,purch_price:purch});
        setRowItem({});

    };

    const onRowDelete = async (rowdata) => {
        var newData = itemsComms.filter((obj) => obj.mat_id !== rowdata.mat_id);
        const newItems = newData.map((row, i) => {
            return {
                ...row,
                no: i,
            };
        });
        setItemsComms([...newItems]);
        let purch=newItems?.reduce((a, v) => (a = a + parseFloat(v.price* v.mat_quan)), 0).toFixed(2);
        setItems({...items,purch_price:purch});
        setConfirmDialog(false);
    }
    // useEffect(() => {
    // }, [currUnitList]);
    const claslbls = useStylesLbl();

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper} 
        style={{   minHeight: 85 }}>
            <Table
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#f18584",
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {t('forms:no')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t('forms:item')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("unit")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t('forms:quanity')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"اجمالي الكمية"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t('forms:price')}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("delete")}
                        </TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {itemsComms.map((row, i) => (
                        <TableRow key={row.no}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center"  > {i + 1}</TableCell>
                            <TableCell style={stylRo} align="center"  > {row?.itemName ?? ""}</TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editUnit", event, row)}
                            >
                                {
                                    row?.editUnit ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasAo}
                                            value={rowItem.defUnit}
                                            onChange={(event, newValue) => {
                                                changeAutoUnits(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={rowItem.units}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.unitName
                                            }
                                            // onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                            disableClearable
                                            style={{ backgroundColor: colors.red[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={""}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbls.clrBlackLblS }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row.unitName
                                        )

                                }
                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editquan", event, row)}
                            >
                                {
                                    row.editquan ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="mat_quan"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.red[50] }}
                                                    type="number"
                                                    name="mat_quan"
                                                    onBlur={(e) => EnterChangeTtems("mat_quan", rowItem, row)}
                                                    value={rowItem.mat_quan}
                                                    onChange={MathChangIdataTtems("mat_quan", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("mat_quan", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("mat_quan", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.mat_quan)?.toFixed(2)
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center"  > {parseFloat(row.mat_quantot)?.toFixed(2) ?? ""}</TableCell>
                            <TableCell style={stylRo} align="center"  > {parseFloat(row.price)?.toFixed(2) ?? ""}</TableCell>

                            <TableCell align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={() => {
                                        setConfirmDialog({
                                            isOpen: true,
                                            onConfirm: () => {
                                                onRowDelete(row);
                                            },
                                        })
                                    }}>

                                    <DeleteIcon size={"small"} />
                                </IconButton>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
